import ListGroup from "react-bootstrap/ListGroup";

import {
  Position,
  NMEAQualityCode,
  NMEAQualityPriority,
  NMEAQualityName,
} from "../../types";
import { nmeaQuality } from "../../utils";

interface NMEAStatusProps {
  positions: Position[];
  minQuality: NMEAQualityCode;
}

export default function NMEAStatus({ positions, minQuality }: NMEAStatusProps) {
  const minPriority = NMEAQualityPriority[minQuality];
  const qualityCode = nmeaQuality(positions);

  const priority = NMEAQualityPriority[qualityCode ?? NMEAQualityCode.GPS];
  const name =
    qualityCode !== undefined ? NMEAQualityName[qualityCode] : "Not available";
  const ok = priority >= minPriority;

  return (
    <ListGroup.Item variant={ok ? "" : "danger"}>
      <div className="d-flex">
        <strong>Location quality</strong>
        <div className="ms-auto">{name}</div>
      </div>
    </ListGroup.Item>
  );
}
